import React from "react";
import { css } from "@emotion/css";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";
import {
    whyJoin,
    stopCrazyThoughtsIcon,
    holdGreatMomentsIcon,
    chooseBestSelfIcon,
    createHarmonySelfIcon,
    releaseUnwantedThingsIcon,
} from "../assets/images";

const { FiTarget, FiStar, FiMail, FiPhone, FiHeart, FiZap } = FiIcons;

const ConnectTo = () => {
    const connectToStyles = {
        section: css`
            background-color: white;
            padding: 3rem 0 2rem;
            margin-top: 1rem;
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;

            @media (min-width: 640px) {
                padding: 0 1.5rem;
            }

            @media (min-width: 1024px) {
                padding: 0 2rem;
            }
        `,
        grid: css`
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 30px;
            align-items: stretch;

            @media (min-width: 640px) {
                gap: 40px;
            }

            @media (min-width: 1024px) {
                grid-template-columns: repeat(2, 1fr);
                gap: 40px;
                align-items: stretch;
            }
        `,
        leftColumn: css`
            display: flex;
            flex-direction: column;
            gap: 24px;
            height: 100%;
            position: relative;

            @media (min-width: 640px) {
                gap: 28px;
            }

            @media (min-width: 1024px) {
                gap: 32px;
            }
        `,
        connectToBanner: css`
            background-color: #ffe0e0;
            color: #d04b4b;
            padding: 7px 20px;
            border-radius: 10px;
            font-weight: 700;
            font-size: 1rem;
            text-align: center;
            margin: 0;
            position: absolute;
            top: -20px;
            left: 15px;

            @media (min-width: 640px) {
                font-size: 1.125rem;
            }

            @media (min-width: 1024px) {
                font-size: 1.25rem;
            }
        `,
        tilesGrid: css`
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
            border: 1px solid #ede9e9;
            border-radius: 4px;
            padding: 20px 10px 10px;

            @media (min-width: 640px) {
                gap: 14px;
            }

            @media (min-width: 1024px) {
                gap: 16px;
            }
        `,
        tile: css`
            border-radius: 8px;
            padding: 16px;
            text-align: center;
            transition: all 0.3s;
            cursor: pointer;
            box-shadow: 3px 4px 5px -5px rgba(0, 0, 0, 0.1);

            @media (min-width: 640px) {
                padding: 18px;
            }

            @media (min-width: 1024px) {
                padding: 20px;
            }

            ${
                "" /* &:hover {
                background-color: #e5e7eb;
                transform: translateY(-2px);
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
                    0 4px 6px -2px rgba(0, 0, 0, 0.05);
            } */
            }
        `,
        tileIcon: css`
            ${"" /* background-color: #dbeafe; */}
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 10px;
            border-radius: 5px;
            background: #fcfcfc;
            @media (min-width: 640px) {
                width: 44px;
                height: 44px;
                margin: 0 auto 11px;
            }

            @media (min-width: 1024px) {
                width: 48px;
                height: 48px;
                margin: 0 auto 12px;
            }
        `,
        icon: css`
            width: 20px;
            height: 20px;
            color: #2563eb;

            @media (min-width: 640px) {
                width: 22px;
                height: 22px;
            }

            @media (min-width: 1024px) {
                width: 24px;
                height: 24px;
            }
        `,
        customIcon: css`
            width: 20px;
            height: 20px;
            object-fit: contain;

            @media (min-width: 640px) {
                width: 22px;
                height: 22px;
            }

            @media (min-width: 1024px) {
                width: 24px;
                height: 24px;
            }
        `,
        tileTitle: css`
            font-weight: 600;
            color: #1f2937;
            font-size: 0.75rem;
            line-height: 1.25;

            @media (min-width: 640px) {
                font-size: 0.8125rem;
            }

            @media (min-width: 1024px) {
                font-size: 0.875rem;
            }
        `,
        rightColumn: css`
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 100%;

            @media (min-width: 640px) {
                gap: 22px;
            }

            @media (min-width: 1024px) {
                gap: 24px;
            }
        `,
        whyJoinSection: css`
            text-align: center;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
        whyJoinTitle: css`
            font-size: 1.25rem;
            font-weight: bold;
            color: #1f2937;
            margin-bottom: 12px;

            @media (min-width: 640px) {
                font-size: 1.375rem;
                margin-bottom: 14px;
            }

            @media (min-width: 1024px) {
                font-size: 1.5rem;
                margin-bottom: 16px;
            }
        `,
        whyJoinImage: css`
            width: 100%;
            height: 200px;
            object-fit: fill;
            border-radius: 8px;
            margin: 0 auto;
            ${
                "" /* box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05); */
            }

            @media (min-width: 640px) {
                height: 240px;
                width: 400px;
            }

            @media (min-width: 1024px) {
                height: 277px;
                width: 400px;
            }
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }

            @media (max-width: 768px) {
                text-align: justify;
            }
        `,
    };

    const tiles = [
        {
            icon: stopCrazyThoughtsIcon,
            title: "Stop crazy thoughts",
            isCustomIcon: true,
        },
        {
            icon: releaseUnwantedThingsIcon,
            title: "Release unwanted things",
            isCustomIcon: true,
        },
        {
            icon: chooseBestSelfIcon,
            title: "Choose best for self",
            isCustomIcon: true,
        },
        {
            icon: holdGreatMomentsIcon,
            title: "Hold great moments in life",
            isCustomIcon: true,
        },
        {
            icon: chooseBestSelfIcon,
            title: "Choose best for self",
            isCustomIcon: true,
        },
        {
            icon: createHarmonySelfIcon,
            title: "Create Harmony with self",
            isCustomIcon: true,
        },
    ];

    return (
        <section className={connectToStyles.section}>
            <div className={connectToStyles.container}>
                <div className={connectToStyles.grid}>
                    {/* Left Column */}
                    <div className={connectToStyles.leftColumn}>
                        <div className={connectToStyles.connectToBanner}>
                            Connect To...
                        </div>

                        <div className={connectToStyles.tilesGrid}>
                            {tiles.map((tile, index) => (
                                <div
                                    key={index}
                                    className={connectToStyles.tile}
                                >
                                    <div className={connectToStyles.tileIcon}>
                                        {tile.isCustomIcon ? (
                                            <img
                                                src={tile.icon}
                                                alt={tile.title}
                                                className={
                                                    connectToStyles.customIcon
                                                }
                                            />
                                        ) : (
                                            <SafeIcon
                                                icon={tile.icon}
                                                className={connectToStyles.icon}
                                            />
                                        )}
                                    </div>
                                    <h3 className={connectToStyles.tileTitle}>
                                        {tile.title}
                                    </h3>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className={connectToStyles.rightColumn}>
                        <div className={connectToStyles.whyJoinSection}>
                            <h2 className={connectToStyles.whyJoinTitle}>
                                Why Join?
                            </h2>
                            <img
                                src={whyJoin}
                                alt="Why Join Club Mango"
                                className={connectToStyles.whyJoinImage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConnectTo;
